import { Box } from '@mui/material';

/*COMPONENTES PARA LA FUNCIONALIDAD DE TAB*/
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: '20px 0px',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}
